export const ROUTE_DASHBOARD = '/';
export const ROUTE_FIELDS = '/fields';
export const ROUTE_FIELDS_ADD = `${ROUTE_FIELDS}/add`;
export const ROUTE_FIELDS_UPLOAD = `${ROUTE_FIELDS}/upload`;
export const ROUTE_FIELDS_DETAIL = `${ROUTE_FIELDS}/detail`;
export const ROUTE_FIELDS_EDIT = `${ROUTE_FIELDS}/edit`;
export const ROUTE_STORAGE = '/storage';
export const ROUTE_STORAGE_ADD = `${ROUTE_STORAGE}/add`;
export const ROUTE_STORAGE_EDIT = `${ROUTE_STORAGE}/edit`;
export const ROUTE_STORAGE_DETAIL = `${ROUTE_STORAGE}/detail`;
export const ROUTE_ACTIVITY = '/activity';
export const ROUTE_ACTIVITY_ADD = `${ROUTE_ACTIVITY}/add`;
export const ROUTE_ACTIVITY_ADD_STORAGE = `${ROUTE_ACTIVITY}/add/STORAGE`;
export const ROUTE_ACTIVITY_ADD_SEEDING = `${ROUTE_ACTIVITY}/add/SEEDING`;
export const ROUTE_ACTIVITY_DETAIL = `${ROUTE_ACTIVITY}/detail`;
export const ROUTE_ACTIVITY_ADD_TYPE = type =>
  `${ROUTE_ACTIVITY}/add/${(type && type.toUpperCase()) || ''}`;
// export const ROUTE_ACTIVITY_EDIT = `${ROUTE_ACTIVITY}/edit`;
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_FORGOT_PASSWORD = '/forgot';
export const ROUTE_SIGNIN = '/signin';
export const ROUTE_CONTRACTS = '/contracts';
export const ROUTE_CONTRACTS_ADD = `${ROUTE_CONTRACTS}/add`;
export const ROUTE_CONTRACTS_DETAIL = `${ROUTE_CONTRACTS}/detail`;
export const ROUTE_CONTRACTS_EDIT = `${ROUTE_CONTRACTS}/edit`;
export const ROUTE_CONFIRM_EMAIL = '/confirm_email';
export const ROUTE_CONFIRM_USER = '/confirmUser';

export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const REGISTER_PENDING = 'REGISTER_PENDING';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILED = 'REGISTER_FAILED';

export const LOGOUT_PENDING = 'LOGOUT_PENDING';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';
export const FORGOT_PASSWORD_PENDING = 'FORGOT_PASSWORD_PENDING';

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RESET_PASSWORD_PENDING = 'RESET_PASSWORD_PENDING';

export const LOGIN_ERRORS = {
  USER_NOT_FOUND: 'UserNotFoundException',
  USER_NOT_CONFIRMED: 'UserNotConfirmedException',
  USER_NOT_AUTHORIZED: 'NotAuthorizedException',
};

export const REGISTER_ERRORS = {
  USERNAME_EXISTS: 'UsernameExistsException',
  INVALID_PASSWORD: 'InvalidPasswordException',
  INVALID_PARAMETER: 'InvalidParameterException',
  TERMS_NOT_ACCEPTED: 'TermsNotAccepted',
};

export const RESET_PASSWORD_ERRORS = {
  CODE_MISMATCH: 'CodeMismatchException',
};

export const ERROR_DEFAULT =
  'Something went wrong. Please refresh the page and try again.';

export const OFFLINE_WARNING = 'No internet connection. Grow is offline.';

export const BREAKPOINT_MOBILE_MAX = 768;
export const BREAKPOINT_DESKTOP_MIN = 769;

// See src/styles/_variables.scss
const cssGap = 32;
export const BREAKPOINT_CSS_TABLET_MIN = 769;
export const BREAKPOINT_CSS_DESKTOP_MIN = 960 + 2 * cssGap;
export const BREAKPOINT_CSS_WIDESCREEN_MIN = 1152 + 2 * cssGap;
export const BREAKPOINT_CSS_FULLHD_MIN = 1344 + 2 * cssGap;

export const FIELD_DISPLAY_TOGGLE = 'FIELD_DISPLAY_TOGGLE';
export const FIELD_LIST_SUCCESS = 'FIELD_LIST_SUCCESS';
export const FIELD_CREATE_SUCCESS = 'FIELD_CREATE_SUCCESS';
export const FIELD_CREATE_ERROR = 'FIELD_CREATE_ERROR';
export const REMOVE_LOCAL_FIELD = 'REMOVE_LOCAL_FIELD';

// Google Map Action Types
export const CLEAR_MARKER = 'CLEAR_MARKER';
export const RESET_SELECTED_FIELD = 'RESET_SELECTED_FIELD';
export const RESET_SELECTED_STORAGE = 'RESET_SELECTED_STORAGE';
export const UPDATE_BOUNDS = 'UPDATE_BOUNDS';
export const UPDATE_CROP_PRICE_STATUS = 'UPDATE_CROP_PRICE_STATUS';
export const UPDATE_FEATURES = 'UPDATE_FEATURES';
export const UPDATE_FORM_NAME = 'UPDATE_FORM_NAME';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const UPDATE_MAP_FIELDS = 'UPDATE_MAP_FIELDS';
export const UPDATE_MAP_STORAGES = 'UPDATE_MAP_STORAGES';
export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS';
export const UPDATE_SEASON = 'UPDATE_SEASON';
export const UPDATE_SELECTED_FIELD = 'UPDATE_SELECTED_FIELD';
export const UPDATE_SELECTED_STORAGE = 'UPDATE_SELECTED_STORAGE';
export const UPDATE_ZOOM = 'UPDATE_ZOOM';
export const UPDATE_MAX_PLANTING_AREA = 'UPDATE_MAX_PLANTING_AREA';

// Scouting acitivty enum
export const SCOUTING = {
  WEEDS: 'WEEDS',
  INSECTS: 'INSECTS',
};

// activities
export const ACTIVITY_TYPES = {
  // FIELD: 'FIELD',
  HARVESTING: 'HARVESTING',
  STORAGE: 'STORAGE',
  DELIVERY: 'DELIVERY',
  SCOUTING: 'SCOUTING',
  FERTILIZING: 'FERTILIZING',
  SPRAYING: 'SPRAYING',
  SEEDING: 'SEEDING',
  OTHER: 'OTHER',
};

export const OTHER_ACTIVITY_TYPES = {
  TILLING: 'TILLING',
  IRRIGATION: 'IRRIGATION',
  CUSTOM: 'CUSTOM',
};

// field activities
export const FIELD_ACTIVITY_TYPES = [
  ACTIVITY_TYPES.SEEDING,
  ACTIVITY_TYPES.SCOUTING,
  ACTIVITY_TYPES.FERTILIZING,
  ACTIVITY_TYPES.SPRAYING,
  ACTIVITY_TYPES.HARVESTING,
  OTHER_ACTIVITY_TYPES.TILLING,
  OTHER_ACTIVITY_TYPES.IRRIGATION,
  OTHER_ACTIVITY_TYPES.CUSTOM,
];

export const ALL_SORTED_ACTIVITIES = [
  ACTIVITY_TYPES.FERTILIZING,
  ACTIVITY_TYPES.SCOUTING,
  ACTIVITY_TYPES.SEEDING,
  ACTIVITY_TYPES.SPRAYING,
  ACTIVITY_TYPES.HARVESTING,
  ACTIVITY_TYPES.STORAGE,
  ACTIVITY_TYPES.DELIVERY,
  OTHER_ACTIVITY_TYPES.TILLING,
  OTHER_ACTIVITY_TYPES.IRRIGATION,
  OTHER_ACTIVITY_TYPES.CUSTOM,
];

export const ACTIVITY_NOTES = {
  DELIVERY:
    'Add notes on harvest instructions, storage conditions, grain quality, etc.',
  HARVESTING:
    'Add notes on harvest instructions, storage conditions, grain quality, etc.',
  OTHER:
    'Add notes on harvest instructions, storage conditions, grain quality, etc.',
  SCOUTING: 'Add notes on crop issues, nutrient deficiencies, diseases etc.',
  STORAGE:
    'Add notes on harvest instructions, storage conditions, grain quality, etc.',
  FERTILIZING: 'method, speed, labour, brand, etc',
  SPRAYING: 'drift, nozzle, water ratio, speed, etc',
  SEEDING: 'class, brand, speed, range, etc',
};

// Any new banner ids should be added here so they are added to reducer initial state
export const BANNER_IDS = {
  AUTH: 'AUTH',
  APP: 'APP',
};

export const BANNER_SHOW = 'BANNER_SHOW';
export const BANNER_HIDE = 'BANNER_HIDE';

// used for validations
export const FIELD_SIZE = {
  MAX: 1000000,
  MAX_TITLE: 50,
  MAX_NOTES: 350,
  MIN: 0.01,
  ZERO: 0,
};
export const CROP_SIZE = {
  MAX_TITLE: 50,
  MAX_TITLE_SHORTEN: 30,
  MIN: 0.01,
};
export const STORAGE_SIZE = {
  MAX: 1000000,
  MAX_TITLE: 50,
  MAX_NOTES: 350,
  MIN: 0.01,
};
export const ACTIVITY_SIZE = {
  MAX_BIN: 1000000,
  MAX_OTHER: 50,
  MAX_NOTES: 350,
  MAX_CROP_TITLE: 25,
  MIN: 0.01,
};
export const CONTRACT_SIZE = {
  MAX_BIN: 1000000,
  MAX_TITLE: 50,
  MAX_NOTES: 350,
  MIN: 0.01,
};
export const REGISTER_SIZE = {
  MAX: 1000000000000,
  MIN: 0.01,
  MIN_PASSWORD: 8,
};

export const APP_GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;

// included libraries:
// drawing is for drawing the field polygon
// geometry is to calculate the drawing area size
export const GOOGLE_MAP_API = `https://maps.googleapis.com/maps/api/js?v=3&libraries=drawing,geometry&key=${
  process.env.REACT_APP_GOOGLEMAP_KEY
}`;

export const GEOLOCATION_MESSAGES = {
  NO_PERMISSION:
    'An Error occured: Location Service Disabled, to re - enable, please go to Settings and turn on Location Service.',
  NOT_SUPPORTED:
    'An Error occured: Geolocation is not supported in your browser',
  LOADING: 'Loading your location ...',
};

export const DASHBOARD_MESSAGES = {
  CROP_PRICES_UPDATED: 'Crop prices were successfully updated.',
};

export const COLOR_SCALE = [
  '#006834',
  '#9AAD3E',
  '#EAD10E',
  '#00A3C5',
  '#008C46',

  '#667B00',
  '#AA980A',
  '#006E85',
  '#00B45A',
  '#313B00',

  '#6A5F06',
  '#00AED2',
  '#00753A',
  '#A6C800',
  '#F7DC0F',

  '#00AED2',
  '#004E27',
  '#86A100',
  '#D0BA0C',
  '#00A3C5',
];

// zoom level to enable drawing
export const DRAWING_ZOOM_LEVEL = 13;

import * as ANALYTICS from './analytics';
import * as OPTIONS from './options';
export { ANALYTICS, OPTIONS };



// WEBPACK FOOTER //
// ./src/common/constants/index.js